import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import API_URL from "../config/config";
import "../css/ordersuccess.css";

function OrderSuccess() {
    const location = useLocation();

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const saveStripeOrder = async () => {
            try {
                const params = new URLSearchParams(location.search);

                const sessionId = params.get("session_id");

                if (!sessionId) {
                    setError("Stripe session ID is missing.");
                    setLoading(false);
                    return;
                }

                const res = await axios.post(
                    `${API_URL}/stripe-success-order`,
                    {
                        session_id: sessionId
                    }
                );

                console.log("Stripe Order Response:", res.data);

                setOrder(res.data);
            } catch (err) {
                console.error("Stripe Order Error:", err);

                setError(
                    err.response?.data?.message ||
                    "Unable to process your order."
                );
            } finally {
                setLoading(false);
            }
        };

        saveStripeOrder();
    }, [location.search]);

    if (loading) {
        return (
            <div className="success-page">
                <h1>Processing Your Order...</h1>
                <p>Please wait.</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="success-page">
                <h1>Order Processing Error</h1>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="success-page">
            <h1>Order Successful 🎉</h1>

            <h3>Thank you for your order.</h3>

            <p>
                Order ID: #
                {order?.orderId || "Processing"}
            </p>

            <p>
                Payment Status:{" "}
                {order?.payment_status || "Paid"}
            </p>

            <p>
                Order Status:{" "}
                {order?.order_status || "Processing"}
            </p>

            <h4>
                We will start preparing your order.
            </h4>
        </div>
    );
}

export default OrderSuccess;